import { AfterViewInit, Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SupervisorListDto } from 'src/app/models/supervisor-list.dto';
import { SupervisorFormComponent } from '../supervisor-form/supervisor-form.component';
import { WorkerSubordinatesListDataSource } from './worker-subordinates-list.datasource';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-worker-subordinates-list',
  templateUrl: './worker-subordinates-list.component.html',
  styleUrls: ['./worker-subordinates-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
    trigger('rowExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false
})
export class WorkerSubordinatesListComponent implements AfterViewInit {
  dataSource = inject(WorkerSubordinatesListDataSource);
  private dialog = inject(MatDialog);
  private translateService = inject(TranslateService);

  readonly columns: string[] = ['expandingIcon', 'workerFullName', 'startDate', 'endDate', 'supervisorTypeId'];
  readonly displayedExpandedColumns: string[] = ['workerFullName', 'startDate', 'endDate', 'supervisorTypeId'];

  @Input() workerId: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  expandedElementUserId: number | null = null;
  expansionDataName = 'Subordinates';

  constructor() { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    this.translateService.onLangChange.subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page, this.translateService.onLangChange)
      .pipe(tap(() => this.fetchSubordinates()))
      .subscribe();

    this.fetchSubordinates();
  }

  openModal = (supervisor?: SupervisorListDto) => this.dialog.open(SupervisorFormComponent, { data: supervisor });

  fetchSubordinates = () =>
    !!this.workerId &&
    this.dataSource.subordinatesSubject.next({
      SupervisorId: this.workerId,
      Page: this.paginator.pageIndex + 1,
      PageSize: this.paginator.pageSize,
      SortingField: this.sort.active,
      SortingDirection: this.sort.direction,
    });

  expandRow(expandedElementUserId, userId) {
    this.expandedElementUserId = expandedElementUserId === userId ? null : userId
  }
}
